<template>
  <div class="slider">
    <input
      type="checkbox"
      class="slider-checkbox"
      :id="'slider_' + name"
      v-model="slider_value"
      :true-value="true_value"
      :false-value="false_value"
      :disabled="disabled"
    />
    <label class="slider-label" :for="'slider_' + name">
      <span class="slider-inner"></span>
      <span class="slider-circle"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "OnOffSlider",
  model: {
    prop: "prop_slider_value",
    event: "prop-slider-value-changed"
  },
  props: {
    prop_slider_value: {
      type: String
    },
    name: {
      type: String
    },
    true_value: {},
    false_value: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slider_value: {
      get: function() {
        return this.prop_slider_value;
      },
      set: function(new_value) {
        this.$emit("prop-slider-value-changed", new_value);
      }
    }
  }
};
</script>

<style scoped>
.slider {
  clear: both;
  border: none;
  position: relative;
  user-select: none;
  width: 38px;
  margin-left: 5px;
}

.slider-checkbox {
  display: none;
}

.slider-label {
  border: 0;
  border-radius: 20px;
  cursor: pointer;
  display: block;
  overflow: hidden;
}

.slider-inner {
  display: block;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
  width: 200%;
}

.slider-inner:before,
.slider-inner:after {
  box-sizing: border-box;
  display: block;
  float: left;
  font-size: 9px;
  font-family: "RubikMed";
  height: 16px;
  padding: 0;
  padding-top: 1px;
  width: 50%;
  line-height: 14px;
  text-align: left;
}

.slider-inner:before {
  background-color: #66bb6a;
  color: #fff;
  content: "ON";
  padding-left: 0.75em;
}

.slider-inner:after {
  background-color: #e84653;
  color: #fff;
  content: "OFF";
  padding-right: 5px;
  text-align: right;
}

.slider-circle {
  background-color: #fff;
  border: 0;
  border-radius: 20px;
  bottom: 0;
  display: block;
  margin: 2px;
  position: absolute;
  right: 22px;
  top: 0;
  transition: all 0.3s ease-in 0s;
  width: 12px;
  height: 12px;
}

.slider-checkbox:checked + .slider-label .slider-inner {
  margin-left: 0;
}

.slider-checkbox:checked + .slider-label .slider-circle {
  background-color: #fff;
  right: 0;
}
</style>
